require('es6-promise').polyfill(); //  FÜR Abruf wie google
// import '@babel/polyfill';
// import { enableLogging } from 'mobx-logger';
//import * as Sentry from '@sentry/browser';
//import { Integrations } from '@sentry/tracing';
import { configure } from 'mobx';
import '../utils/extendPrototypes/all';
import './boot_Libs';
import { runtime } from '../classes/runtime/Runtime';
import { RuntimeInjected } from '../classes/runtime/inject/RuntimeInjected';
import { BrowserRuntime } from '../classes/runtime/browser/BrowserRuntime';
// useStrict(true);
// configure mobx on client
// , disableErrorBoundaries: true
// configureMobx({ enforceActions: true });
// declare var NProgress: any;
/*
Date.prototype.dayOfYear = function () {
  const j1 = new Date(this);
  j1.setMonth(0, 0);
  return Math.round((this - j1) / 8.64e7);
};
*/
// bugfix axios-extensions error
configure({ enforceActions: 'never' });
if (typeof window.process === 'undefined') {
    window.process = {
        env: {
            LOGGER_LEVEL: 'info',
        },
    };
}
// ENABLE SENTRY
const isDev = window.location.host.substring(0, 3) === 'dev';
const isQs = window.location.host.substring(0, 2) === 'qs';
////
/*
Sentry.init({
  dsn: 'https://b2fc6b0e3d2c42cbaae78344720a8cad@o526797.ingest.sentry.io/5883939', //https://11434e16f1314248a1e1e16dcd20852d@o447720.ingest.sentry.io/5427913',
  release: 'schlaukopf.2021.1',
  environment: isDev ? 'development' : isQs ? 'quality' : 'production',
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: [/^https?:\/\/([qsdevw])+\.schlaukopf\.([deatch])+/], // mso digital requests also include schalukopf.de in query, therefore stricter regex !!!
    }),
  ],
  whitelistUrls: [/^https?:\/\/([qsdevw])+\.schlaukopf\.([deatch])+/],
  ignoreErrors: [
    'QuotaExceededError',
    'fullscreen error',
    'ResizeObserver loop limit exceeded',
    'googletag.pubads is not a function',
    'ChunkLoadError',
    'chunkId is not defined',
    'SecurityError: The operation is insecure.',
    'invalid callback function',
    'ResizeObserver loop completed with undelivered notifications.',
    'n is not a function',
    'Request failed with status code 500',
  ],
  tracesSampleRate: isDev || isQs ? 1 : 0.01,
});
*/
document.addEventListener('DOMContentLoaded', domContentLoadedHandler);
async function domContentLoadedHandler() {
    if (runtime.browserRuntime) {
        return; // is already rendered
    }
    console.log('BOOT CLIENT');
    console.timeEnd('FROM PAGE_LOAD TO BOOT_CLIENT');
    console.time('FROM BOOT_CLIENT to READY');
    runtime.runtimeInjected = new RuntimeInjected(runtime);
    runtime.browserRuntime = new BrowserRuntime(runtime);
    runtime.browserRuntime.browserBoot.bootBrowserRuntime();
    if ('serviceWorker' in navigator) {
        runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            runtime.browserRuntime.browserServiceWorker.registerServiceWorker();
        });
    }
}
// optional
/*
const config = {
  enabled: true,
  action: false,
  reaction: false,
  transaction: false,
  compute: true
};
*/
// enableLogging(config);
